<template>
  <div>
    <NavBar />
    <!-- <div class="nav">
      <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onClickLeft" />
    </div> -->
    <!-- <div v-if="isShow" style="margin-top:45px">
      <van-empty description="没有更多" />
    </div> -->
    <div v-if="isShow">
        <van-empty description="不存在交存明细或尚未绑定房屋。">
            <span style="font-size:14px;color:blue" @click="openHoused">立即绑定房屋</span>
        </van-empty>
    </div>
    <van-row v-if="!isShow" type="flex" justify="center" class="deposit_list">
      <van-col :span="24">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list v-model:loading="loading" v-model:error="error" error-text="请求失败，点击重新加载" :finished="finished" @load="onLoad">
            <!-- <div class="card" v-for="item in list" :key="item"> -->
            <div class="card" v-for="item in list" :key="item">
              <van-row class="deposit_site">
                <van-col :span="24" style="padding-left:10px;padding-right:10px">{{item.houseSite}}</van-col>
              </van-row>
              <van-row>
                <van-col span="16" class="content_left" style="text-align:left">
                  <van-col span="24" class="deposit_money" style="color:#1989fa;">{{item.totalAmount}}<span style="font-size:13px"> (元)</span></van-col>
                  <van-col span="24">交易编号：{{item.busiNo}}</van-col>
                </van-col>
                <van-col span="7" class="content_right" offset="1">
                  <!-- <van-col span="24" class="deposit_money" style="color:gray">进行中</van-col> -->
                  <van-col span='24'></van-col>
                  <van-col span="24">{{item.createTime.substring(0,10)}}</van-col>
                </van-col>
              </van-row>
              <van-row class="deposit_button">
                <van-col :span="24" style="margin-bottom:10px">
                  <van-button type="primary" round size="small" @click="OpenInvoice(item)">查看发票</van-button>
                </van-col>
              </van-row>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-col>
    </van-row>
  </div>
</template>
<script>
  import VueCookie from 'vue-cookie'
  export default {
    data() {
      return {
        // title:this.$route.name,
        error: false,
        refreshing:false,
        isShow:false,
        loading: false,
        finished: false,
        list: [],
        regionName: "",
      };
    },
    // beforeRouteLeave(to,from,next){
    //   console.log(to)
    //   if(to.name=='房屋管理'){
    //     next(true)
    //   }
    //   else if(to.fullPath=='/'){
    //     return next()
    //   }
    //   else if(to.fullPath=='/HouseDetails'){
    //     return next('/')
    //   }
    //   else if(to.fullPath=='/QueryResult'){
    //     return next('/')
    //   } 
    // },
    methods: {
       onClickLeft() {
        // history.go(-1);
        this.$router.push({path:'/'})
      },
      onLoad() {
        let data={
          // openId:'o5AgcxDoREhPpdd0wzkSYvfnSKmQ',
          // openId:'o5AgcxKDu14LYiSrhGBzj_rMu7ZM',
          openId:VueCookie.get('openid'),
          pageNum:1,
          pageSize:100
        }
        this.$postQuery('/WeChatPay/getDepReqDetailList', data).then((response) => {
          console.log(response)
          if (this.refreshing) {
              this.list = [];
              this.refreshing = false;
          }
          if(response.code==200){
            if(response.data.list.length==0){
              this.isShow = true
            }else{
              this.list = response.data.list
              this.loading = false;
              if (this.list.length >= response.data.list.length) {
                  this.finished = true;
              }
            }
          }
        }).catch(()=>{
          this.error = true;
          this.loading = false
        })
      },
      onRefresh(){
          // 清空列表数据
          this.finished = false;
          //重新加载数据
          this.loading = true;
          this.onLoad();
      },
      houseTest() {

      },
      /**
       * 申请发票
       */
      OpenInvoice(item){
        console.log(item)
        let data={
          busiNo:item.busiNo,
          openId:VueCookie.get('openid'),
          // openId:'o5AgcxDoREhPpdd0wzkSYvfnSKmQ'
        }
        this.$postQuery('/WeChatPay/getInviceInfoByReqNo', data).then((response) => {
          // console.log(response)
          if(response.code==200){
            window.location.href = response.data[0]
          }
        })
      },
      openHoused(){
        this.$router.replace({
          path:'/HousingManagement'
        })
      }
    },
    mounted() {},
    created() {
      this.regionName = this.$route.query.regionName;

    },
  }
</script>
<style>
.list {
    margin-top: 46px;
}
  .deposit_list .card {
    padding: 5px 10px;
    font-size: 12px;
  }

  .deposit_list .van-col {
    margin-top: 10px;
    /* margin-bottom: 10px; */
  }

  .deposit_list {
    margin-top: 46px;
  }

  .deposit_money {
    font-size: 18px;
    font-weight: bold;
  }

  .deposit_site {
    font-size: 14px;
    font-weight: bold;
  }

  .projcet_name {
    width: calc(100% - 3rem - 10px);
  }

  .projcet_state {
    width: 3rem;
    margin-left: 6px;
  }

  .content_left {
    text-align: left;
    padding-left: 10px;
  }

  .content_right {
    text-align: center;
  }

  .deposit_button .van-button {
    width: 100%;
  }
</style>